import { render, staticRenderFns } from "./ChangeEmailCard.vue?vue&type=template&id=4a6af25b&"
import script from "./ChangeEmailCard.vue?vue&type=script&lang=ts&"
export * from "./ChangeEmailCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports